import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalComponent } from './modal.component';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { TestModalChildComponent } from './test-modal-child.component';

@NgModule({
    imports: [
        CommonModule,
        FontIconModule,
    ],
    declarations: [
        ModalComponent,
        TestModalChildComponent,
    ],
    providers: [],
    exports: [
        ModalComponent,
    ],
    entryComponents: [ModalComponent, TestModalChildComponent]
})
export class ModalModule {
    static entry = ModalComponent;
}
